import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

let client = null;
let hasWarnedMissingConfig = false;

function getSupabaseClient() {
  if (!supabaseUrl || !supabaseAnonKey) {
    if (!hasWarnedMissingConfig) {
      hasWarnedMissingConfig = true;
      console.warn(
        "Supabase client is disabled: missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY"
      );
    }
    return null;
  }

  if (!client) {
    client = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: false,
      },
    });
  }

  return client;
}

export { getSupabaseClient };
export default getSupabaseClient;
